<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Centros de Custos</h5>
                <hr>

				<div class="p-fluid p-formgrid p-grid">
					<div class="p-field p-col-12 p-md-6">
						<label>Empresa</label>
						<Dropdown v-model.number="idCnpjsSelecionado" @change="listarDepartamentos" :options="cnpjs" 
							optionLabel="razaoSocial" optionValue="id" placeholder="Selecione"/>
					</div>				             
				</div>
				<div class="p-fluid p-formgrid p-grid">
					<div class="p-field p-col-12 p-md-6">
						<label>Departamento</label>
						<Dropdown v-model.number="idDepartamentoSelecionado" @change="listarSetores" :options="ctcsDepartamentos" 
							optionLabel="nome" optionValue="id" placeholder="Selecione" :filter="true"/>
					</div>
					<div class="p-field p-col-0">
						<label style="color:#ffffff">.</label>
						<span class="p-buttonset">
							<Button label="Novo" icon="pi pi-plus" v-if="permissaoNovo" @click="novo('Departamento')"/>
							<Button label="Editar" icon="pi pi-pencil" class="p-button-success" v-if="permissaoEditar" @click="editar('Departamento')"/>
							<Button label="Excluir" icon="pi pi-trash" class="p-button-danger" v-if="permissaoExcluir" @click="confirmarExcluir('Departamento')"/>
						</span>
					</div>							            
				</div>
				<div class="p-fluid p-formgrid p-grid">
					<div class="p-field p-col-12 p-md-6">
						<label>Setor</label>
						<Dropdown v-model.number="idSetorSelecionado" @change="listarSecoes" :options="ctcsSetores" 
							optionLabel="nome" optionValue="id" placeholder="Selecione" :filter="true"/>
					</div>	
					<div class="p-field p-col-0">
						<label style="color:#ffffff">.</label>
						<span class="p-buttonset">
							<Button label="Novo" icon="pi pi-plus" v-if="permissaoNovo" @click="novo('Setor')"/>
							<Button label="Editar" icon="pi pi-pencil" class="p-button-success" v-if="permissaoEditar" @click="editar('Setor')"/>
							<Button label="Excluir" icon="pi pi-trash" class="p-button-danger" v-if="permissaoExcluir" @click="confirmarExcluir('Setor')"/>
						</span>
					</div>						            
				</div>
				<div class="p-fluid p-formgrid p-grid">
					<div class="p-field p-col-12 p-md-6">
						<label>Seção</label>
						<Dropdown v-model.number="idSecaoSelecionado" :options="ctcsSecoes" 
							optionLabel="nome" optionValue="id" placeholder="Selecione" :filter="true"/>
					</div>	
					<div class="p-field p-col-0">
						<label style="color:#ffffff">.</label>
						<span class="p-buttonset">
							<Button label="Novo" icon="pi pi-plus" v-if="permissaoNovo" @click="novo('Seção')"/>
							<Button label="Editar" icon="pi pi-pencil" class="p-button-success" v-if="permissaoEditar" @click="editar('Seção')"/>
							<Button label="Excluir" icon="pi pi-trash" class="p-button-danger" v-if="permissaoExcluir" @click="confirmarExcluir('Seção')"/>
						</span>
					</div>						            
				</div>		

			</div>

			<Dialog :visible.sync="exibirDialogCadastro" :header="tituloModal" :modal="true" class="p-fluid" :style="{width: '500px'}">			
				<div class="p-fluid p-formgrid p-grid">
					<div class="p-field p-col-6 p-md-6">
						<label for="codigo">Código</label>
						<InputText id="codigo" v-model.trim="centroCusto.codigo" required="true" autocomplete="off" maxlength="12" 
						:disabled="!editarCodigo"/>
						<small class="p-invalid" v-if="enviandoForm && !centroCusto.gerarCodogioEmSequencia && !centroCusto.codigo">Informe o código</small>
					</div>	
					<div class="p-field p-col-6 p-md-6" v-if="centroCusto.id == null">
						<label style="color: #ffffff">.</label>
						<div class="p-field-checkbox">
							<Checkbox v-model="centroCusto.gerarCodogioEmSequencia" :binary="true" @click="validiarEditarCodigo"/>
							<label>Geração Automática</label>
						</div>
					</div>				
				</div>					
				<div class="p-fluid p-formgrid p-grid">					
					<div class="p-field p-col">
						<label for="nome">Nome</label>
						<InputText id="nome" v-model.trim="centroCusto.nome" required="true" autocomplete="off" maxlength="50"/>
						<small class="p-invalid" v-if="enviandoForm && !centroCusto.nome">Informe o nome</small>
					</div>
				</div>				
				<template #footer>
					<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
					<Button label="Salvar" icon="pi pi-check" @click="salvar"/>
				</template>
			</Dialog>

			<Dialog :visible.sync="exibirDialogConfirmarExcluir" @hide="fecharModal" header="Confirmar" :modal="true" :style="{width: '450px'}">
				<div class="confirmation-content">
					<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
					<span>Excluir {{ centroCusto.tipo }} <b>{{ centroCusto.nome }}</b>?</span>
				</div>
				<template #footer>
					<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
					<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
				</template>
			</Dialog>

		</div>
	</div>
</template>

<script>
import CentroCustoService from '@/service/CentroCustoService';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
	centroCustoService: null,
	data() {
		return {
			tituloModal: 'Novo',
			exibirDialogCadastro: false,
			exibirDialogConfirmarExcluir: false,
			enviandoForm: false,
			centroCusto: new CentroCusto(),
			permissaoNovo: false,
			permissaoEditar: false,
			permissaoExcluir: false,
			editarCodigo: false,
			ctcsDepartamentos: [],
			ctcsSetores: [],
			ctcsSecoes: [],
			cnpjs: [],
			idCnpjsSelecionado: null,
			idDepartamentoSelecionado: null,
			idSetorSelecionado: null,
			idSecaoSelecionado: null,
		}		
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getCacheEmpresa']),
		salvar() {			
			if(this.centroCusto.id == null) {
				if(this.centroCusto.tipo == 'Departamento') {
					this.salvarDepartamento();
				} else {
					this.salvarSetorSecao();
				}
			} else {
				this.alterar();
			}			
		},
		salvarDepartamento() {
			this.enviandoForm = true;
			if(this.centroCusto.id) {				
				this.centroCusto.gerarCodogioEmSequencia = false;
				if(this.centroCusto.nome == '' || this.centroCusto.codigo == '') {					
					return;
				}
			} else {				
				if(this.centroCusto.gerarCodogioEmSequencia && this.centroCusto.nome == '') {					
					return;
				}
				if(!this.centroCusto.gerarCodogioEmSequencia && (this.centroCusto.nome == '' || this.centroCusto.codigo == '')) {					
					return;
				}
			}
			let requisicao = {
				idCnpj: this.idCnpjsSelecionado,
				centroCusto: {...this.centroCusto},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.centroCustoService.salvarDepartamento(requisicao)
			.then(resp => {							
				this.fecharModal();
				this.listarDepartamentos();
				exibirMensagem(this, resp);						
			})
			.catch(erro => {exibirMensagem(this, erro)});			
		},
		salvarSetorSecao() {
			this.enviandoForm = true;
			if(this.centroCusto.id) {				
				this.centroCusto.gerarCodogioEmSequencia = false;
				if(this.centroCusto.nome == '' || this.centroCusto.codigo == '') {					
					return;
				}
			} else {				
				if(this.centroCusto.gerarCodogioEmSequencia && this.centroCusto.nome == '') {					
					return;
				}
				if(!this.centroCusto.gerarCodogioEmSequencia && (this.centroCusto.nome == '' || this.centroCusto.codigo == '')) {					
					return;
				}
			}
			let requisicao = {
				idCnpj: this.idCnpjsSelecionado,
				idCentroCustoPai: (this.centroCusto.tipo == 'Setor' ? this.idDepartamentoSelecionado : this.idSetorSelecionado),
				centroCusto: {...this.centroCusto},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.centroCustoService.salvarSetorSecao(requisicao)
			.then(resp => {							
				if(this.centroCusto.tipo == 'Setor') {						
					this.listarSetores();
				} else {							
					this.listarSecoes();
				}			
				this.fecharModal();	
				exibirMensagem(this, resp);						
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		alterar() {
			this.enviandoForm = true;
			if(this.centroCusto.nome != '' && this.centroCusto.codigo != '') {
				let requisicao = {
					centroCusto: {...this.centroCusto},
					usuarioRequisicao: {...this.getDadosRequisicao()}
				}			
				this.centroCustoService.alterar(requisicao)
				.then(resp => {							
					if(this.centroCusto.tipo == 'Departamento') {						
						this.listarDepartamentos();
					} else if(this.centroCusto.tipo == 'Setor') {							
						this.listarSetores();
					} else {
						this.listarSecoes();
					}			
					this.fecharModal();	
					exibirMensagem(this, resp);						
				})
				.catch(erro => {exibirMensagem(this, erro)});
			}			
		},
		excluir() {
			let requisicao = {
				centroCusto: {...this.centroCusto},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.centroCustoService.excluir(requisicao)
			.then(resp => {
				if(this.centroCusto.tipo == 'Departamento') {						
					this.listarDepartamentos();
				} else if(this.centroCusto.tipo == 'Setor') {							
					this.listarSetores();
				} else {
					this.listarSecoes();
				}			
				this.fecharModal();	
				exibirMensagem(this, resp);						
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		novo(tipo) {		
			this.enviandoForm = false;	
			if(tipo == 'Departamento' && this.idCnpjsSelecionado == null) {
				exibirMensagemSis(this, 'Selecione uma empresa', true);
				return;
			}
			if(tipo == 'Setor' && this.idDepartamentoSelecionado == null) {
				exibirMensagemSis(this, 'Selecione um departamento', true);
				return;
			}
			if(tipo == 'Seção' && this.idSetorSelecionado == null) {
				exibirMensagemSis(this, 'Selecione um setor', true);
				return;
			}
			this.centroCusto = new CentroCusto();
			this.editarCodigo = false;
			this.centroCusto.gerarCodogioEmSequencia = true;
			this.centroCusto.tipo = tipo;
			this.tituloModal = 'Novo '+tipo;
			this.exibirDialogCadastro = true;
		},
		editar(tipo) {		
			this.enviandoForm = false;	
			if(tipo == 'Departamento' && this.idDepartamentoSelecionado == null) {
				exibirMensagemSis(this, 'Selecione uma departamento', true);
				return;
			}
			if(tipo == 'Setor' && this.idSetorSelecionado == null) {
				exibirMensagemSis(this, 'Selecione um setor', true);
				return;
			}
			if(tipo == 'Seção' && this.idSecaoSelecionado == null) {
				exibirMensagemSis(this, 'Selecione uma seção', true);
				return;
			}
			this.editarCodigo = false;
			if(tipo == 'Departamento') {
				this.buscar(this.idDepartamentoSelecionado);
			} else if(tipo == 'Setor') {
				this.buscar(this.idSetorSelecionado);
			} else if(tipo == 'Seção') {
				this.buscar(this.idSecaoSelecionado);
			}		
		},
		validiarEditarCodigo() {
			if(this.centroCusto.gerarCodogioEmSequencia && this.centroCusto.id == null) {
				this.editarCodigo = true;
				return;
			}
			this.editarCodigo = false;
		},
		confirmarExcluir(tipo) {
			if(tipo == 'Departamento' && this.idDepartamentoSelecionado == null) {
				exibirMensagemSis(this, 'Selecione uma departamento', true);
				return;
			}
			if(tipo == 'Setor' && this.idSetorSelecionado == null) {
				exibirMensagemSis(this, 'Selecione um setor', true);
				return;
			}
			if(tipo == 'Seção' && this.idSecaoSelecionado == null) {
				exibirMensagemSis(this, 'Selecione uma seção', true);
				return;
			}
			let ctcsFiltrar = null;
			let idSelecionado = null;
			if(tipo == 'Departamento') {
				ctcsFiltrar = this.ctcsDepartamentos;
				idSelecionado = this.idDepartamentoSelecionado;
			} else if(tipo == 'Setor') {
				ctcsFiltrar = this.ctcsSetores;
				idSelecionado = this.idSetorSelecionado;
			} else if(tipo == 'Seção') {
				ctcsFiltrar = this.ctcsSecoes;
				idSelecionado = this.idSecaoSelecionado;
			}
			for(let i = 0; i < ctcsFiltrar.length; i++) {
				let ctc = ctcsFiltrar[i];
				if(ctc.id == idSelecionado) {
					this.centroCusto = ctc;
					break;
				}
			}		
			this.exibirDialogConfirmarExcluir = true;			
		},
		buscar(idCentroCusto) {			
			let requisicao = {		
				idCentroCusto: idCentroCusto,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.centroCustoService.buscar(requisicao)
			.then(resp => {	
				this.centroCusto = resp.data;
				this.tituloModal = 'Editar '+this.centroCusto.tipo;
				this.exibirDialogCadastro = true;									
			})
			.catch(erro => {exibirMensagem(this, erro)});						
		},
		fecharModal(){
			this.centroCusto = new CentroCusto();
			this.exibirDialogCadastro = false;
			this.exibirDialogConfirmarExcluir = false;	
			this.enviandoForm = false;
		},
		listarCnpjs() {			
			// Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
		},
		listarDepartamentos() {
			let requisicao = {
				idCnpj: this.idCnpjsSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.centroCustoService.listarDepartamentos(requisicao)
			.then(resp => {	
				this.ctcsDepartamentos = resp.data;
				this.ctcsSetores = [];
				this.ctcsSecoes = [];
			})
			.catch(erro => {exibirMensagem(this, erro)});			
		},
		listarSetores() {
			let requisicao = {
				idDepartamento: this.idDepartamentoSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.centroCustoService.listarSetores(requisicao)
			.then(resp => {
				this.ctcsSetores = resp.data;
				this.ctcsSecoes = [];
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		listarSecoes() {			
			let requisicao = {
				idSetor: this.idSetorSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.centroCustoService.listarSecoes(requisicao)
			.then(resp => {
				this.ctcsSecoes = resp.data;
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(15);
			this.permissaoEditar = permissoes.includes(16);
			this.permissaoExcluir = permissoes.includes(17);			
		}
	},
	created() {
		this.centroCustoService = new CentroCustoService();		
	},
	mounted() {	
		this.listarCnpjs();
		this.validarPermissoes();			
	}
}
</script>

<style scoped>
</style>